export async function wait(duration) {
    return new Promise((resolve) => {
        setTimeout(resolve, duration);
    });
}

export function startTiming(func = null) {
    const startAt = (new Date()).getTime();

    if (func) {
        func();
    }

    return startAt;
}

export async function stopTiming(startAt, duration, func = null) {
    const now = (new Date()).getTime();

    const timeLeft = Math.max((startAt + duration) - now, 0);

    await wait(timeLeft);

    return func ? func() : null;
}
